export const DEFAULT_TEXT_VARIANT = "V2.body2.neutral.regular" as const;
export const DEFAULT_TEXT_COLOR = "text_Med_Emphasis" as const;

export const FREE_TEXT_VARIANT = "V2.overline.neutral.medium" as const;

export const FREE_TEXT_BANNER_BG =
    "linear-gradient(90deg, rgba(255, 87, 211, 0.06) 1.52%, rgba(252, 200, 239, 0.06) 58.84%, rgba(255, 255, 255, 0.06) 98.63%)";

export const FREE_TEXT_SEPARATOR_GRADIENT = "linear-gradient(90deg, #D9DADB -43.58%, rgba(217, 218, 219, 0.00) 98.39%)";
